import { DateTime } from 'luxon';

import { CopilApi } from '@apps/pata/api/models/copil-api';
import { Satisfaction } from '@apps/surv/domain/models';
import { DatesService } from '@common/services';
import { User } from '@apps/auth/domain/models/back';

export class Copil
{
    public copilId: string;
    public entity: string;
    public entityErpId: string;
    public governorUserName: string;
    public governorFirstLastName: string;
    public projectNumber: string;
    public orderNumber: string;
    public description: string;
    public unit: string;
    public quantity: number;
    public planningDate: DateTime;
    public projectName: string;
    public billCustomer: string;
    public manager: string;
    public managerSup: string;
    public planified: boolean;
    public globalEvaluation: number;

    public monthSatisfaction: Satisfaction;

    public get shortPlanningDate ()
    {
        return this.planningDate.toFormat('yyyyMMdd');
    }
}

export class DomainCopil extends Copil
{
    public static mapperFromApi (source: CopilApi, users: User[], satisfactions: Satisfaction[]): Copil
    {
        const target: Copil = new Copil();

        Object.assign(target, source);

        target.planningDate = DateTime.fromISO(target.planningDate.toLocaleString());

        target.governorFirstLastName = users.find(u => u.userName == source.governorUserName)?.firstLastName;

        target.monthSatisfaction = satisfactions.find(s =>
            DatesService.monthEquals(target.planningDate, DateTime.fromISO(s.surveyDate.toLocaleString()))
        );

        return target;
    }
}